module.exports = __webpack_public_path__ + "img/calendar-20.450f372a.svg";